import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AlertService } from 'app/services/alert.service';
import { LoggerService } from 'app/services/logger.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { PurchaseReceptionService } from '../services/purchase-reception.service';
import * as PurchaseActions from './purchases.actions';

@Injectable()
export class PurchasesEffects {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private logger = inject(LoggerService);
    private _purchaseService = inject(PurchaseReceptionService);
    private _alertService = inject(AlertService);

    messages = {
        getAllError: 'Error getting all purchases',
        connectionError: 'Error connecting to the server',
        unknownError: 'Unknown error',
    };

    // ------------------------------------------------------------------------------------------
    // @ Effects
    // ------------------------------------------------------------------------------------------

    // Get All Purchases
    getAllPurchases$ = createEffect(() =>
        this._actions$.pipe(
            ofType(PurchaseActions.loadPurchases),
            switchMap(() => {
                return this._purchaseService.getAll().pipe(
                    map((res) => {
                        return PurchaseActions.loadPurchasesSuccess({
                            purchases: res.data,
                        });
                    }),
                    catchError((error) =>
                        of(
                            PurchaseActions.loadPurchasesFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Get One Purchase
    // getPurchase$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(PurchaseActions.loadPurchase),
    //         switchMap((action) => {
    //             return this._purchaseService.getOne(action.id).pipe(
    //                 map((res) => {
    //                     return PurchaseActions.loadPurchaseSuccess({
    //                         purchase: res.data,
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         PurchaseActions.loadPurchaseFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // Create Purchase
    createPurchase$ = createEffect(() =>
        this._actions$.pipe(
            ofType(PurchaseActions.createPurchase),
            switchMap((action) => {
                return this._purchaseService.create(action.data).pipe(
                    map((res) => {
                        return PurchaseActions.createPurchaseSuccess({
                            purchase: res.data,
                            success: 'Purchase receipt successfully processed!',
                        });
                    }),
                    catchError((error) =>
                        of(
                            PurchaseActions.createPurchaseFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Update Purchase
    // updatePurchase$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(PurchaseActions.updatePurchase),
    //         switchMap((action) => {
    //             return this._purchaseService
    //                 .update(action.PurchaseData, action.id)
    //                 .pipe(
    //                     map((res) => {
    //                         return PurchaseActions.updatePurchaseSuccess({
    //                             purchase: res.data,
    //                             success: 'Purchase updated successfully',
    //                         });
    //                     }),
    //                     catchError((error) =>
    //                         of(
    //                             PurchaseActions.updatePurchaseFailure({
    //                                 error:
    //                                     error?.error?.message ||
    //                                     this.messages.unknownError,
    //                             })
    //                         )
    //                     )
    //                 );
    //         })
    //     )
    // );

    // Delete Purchase
    // deletePurchase$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(PurchaseActions.deletePurchase),
    //         switchMap((action) => {
    //             return this._purchaseService.delete(action.id).pipe(
    //                 map(() => {
    //                     return PurchaseActions.deletePurchaseSuccess({
    //                         id: action.id,
    //                         success: 'Purchase deleted successfully',
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         PurchaseActions.deletePurchaseFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // ------------------------------------------------------------------------------------------
    // @ Alerts
    // ------------------------------------------------------------------------------------------

    onPurchaseActionSuccess$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(
                    PurchaseActions.createPurchaseSuccess
                    // PurchaseActions.updatePurchaseSuccess,
                    // PurchaseActions.deletePurchaseSuccess
                ),
                tap((action) => {
                    this._alertService.showAlert(action.success, 'success');
                })
            ),
        { dispatch: false }
    );

    onPurchaseActionFailure$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(
                    PurchaseActions.loadPurchasesFailure,
                    PurchaseActions.loadPurchaseFailure,
                    PurchaseActions.createPurchaseFailure
                    // PurchaseActions.updatePurchaseFailure,
                    // PurchaseActions.deletePurchaseFailure
                ),
                tap((action) => {
                    this._alertService.showAlert(action.error, 'error');
                })
            ),
        { dispatch: false }
    );
}
